import { Navigate, Route, Routes } from "react-router-dom";
import MenuHeader1 from "./MenuHeader1";
import NewPrescription from "./Prescriptions/NewPrescription";
import Dashboard from "./Dashboard/Dashboard";
import MyFacilityHome from "./FacilitySettings/MyFacilityHome.js";
import { Links } from "./Utility/Constants.js";
import PatientHome from "./Patients/PatientHome.js";
import AppointmentsHome1 from "./Appointments/AppointmentsHome1.js";
import { AppBar, Box, Grid2, Toolbar } from "@mui/material";
import MyWorklistHome from "./Worklist/MyWorklistHome.js";
import BillHome from "./Billing/BillHome";
import BillList from "./Billing/BillList";
import EnquiryHome from "./Enquiry/EnquiryHome.js";
import PlansHome from "./Plans/PlanHome.js";
import ReportHome from "./Reports/ReportHome.js";
import { useContext, useState } from "react";
import AuthContext from "./Context/AuthProvider.js";
import { canAccess } from "./Utility/Utility.js";

function MasterPage() {
  const auth = useContext(AuthContext);

  const ProtectedRoutes = ({ children, route }) => {
    if((route === Links.root) && canAccess({route: "MyWorklist", roles: auth.auth?.roles})){
      return  <Navigate to={Links.myWorklist}  />;
    }else if((route === Links.root) && canAccess({route: "Report", roles: auth.auth?.roles})){
      return  <Navigate to={Links.reports}  />;
    }
    if (!canAccess({ route: route, roles: auth.auth?.roles })) {
      return <Navigate to="/unauthorized" replace />;
    }
    return children;
  };

  const UnauthorizedPage = () => (
    <div>
      <h2>Access Denied</h2>
      <p>You do not have permission to access this section.</p>
    </div>
  );

  // const InitializeTabs = (tabsStorageKey, defaultTabs) => {
  //   const storedTabs = localStorage.getItem(tabsStorageKey);
  //   if (storedTabs) {
  //     try {
  //       const parsedTabs = JSON.parse(storedTabs);
  //       if (Array.isArray(parsedTabs) && parsedTabs.length > 0) {
  //         return parsedTabs;
  //       }
  //     } catch (error) {
  //       console.error("Error parsing tabs from localStorage:", error);
  //     }
  //   }
  //   return defaultTabs;
  // }

  // const InitializeTabHistory = (tabHistoryStorageKey, defaultHistory) => {
  //   const storedHistory = localStorage.getItem(tabHistoryStorageKey);
  //   if (storedHistory) {
  //     try {
  //       const parsedHistory = JSON.parse(storedHistory);
  //       if (Array.isArray(parsedHistory)) {
  //         return parsedHistory;
  //       }
  //     } catch (error) {
  //       console.error("Error parsing tab history from localStorage:", error);
  //     }
  //   }
  //   return defaultHistory;
  // }

  // const InitializeActiveTab = (activeTabStorageKey, defaultActiveTab) => {
  //   const storedActiveTab = localStorage.getItem(activeTabStorageKey);
  //   if (storedActiveTab) {
  //     return storedActiveTab;
  //   }
  //   return defaultActiveTab;
  // }

  return (
    <Grid2
      direction="column"
      sx={{ height: "100vh", width: "100%" }}
      overflow="hidden"
    >
      <MenuHeader1></MenuHeader1>
      <Grid2
        id="main-content"
        sx={{ 
          height: "95vh", 
          marginTop: "50px",
          marginLeft: "72px", // Default collapsed width
          transition: "margin-left 0.3s ease",
        }}
        overflow="hidden"
      >
        {/* <Grid2 size={12} overflow="hidden" sx={{ height: "100vh" }}> */}
        <Routes>
          <Route
            path={Links.root}
            element={
              <ProtectedRoutes route={Links.root}>
                <MyWorklistHome />
              </ProtectedRoutes>
            }
          />
          <Route path={Links.dashboard} element={<Dashboard></Dashboard>} />

          <Route
            path={Links.allAppointments}
            element={
              <ProtectedRoutes route="Visits">
                <AppointmentsHome1 />
              </ProtectedRoutes>
            }
          />
          <Route
            path={Links.myWorklist}
            element={
              <ProtectedRoutes route="MyWorklist">
                <MyWorklistHome key="1"></MyWorklistHome>
              </ProtectedRoutes>
            }
          />
          <Route
            path={Links.todayQueue}
            element={
              <ProtectedRoutes route="Visits">
                <AppointmentsHome1 />
              </ProtectedRoutes>
            }
          />
          <Route
            path={Links.newAppointment}
            element={
              <ProtectedRoutes route="Visits">
                <AppointmentsHome1 />
              </ProtectedRoutes>
            }
          />
          <Route
            path={Links.rescheduleAppointment}
            element={
              <ProtectedRoutes route="Visits">
                <AppointmentsHome1 />
              </ProtectedRoutes>
            }
          />
          <Route
            path={Links.patient}
            element={<PatientHome></PatientHome>}
          ></Route>
          <Route
            path={Links.basicInformation}
            element={<PatientHome></PatientHome>}
          ></Route>
          <Route
            path={Links.prescriptions}
            element={<PatientHome></PatientHome>}
          ></Route>
          <Route
            path={Links.medicalRecords}
            element={<PatientHome></PatientHome>}
          ></Route>

          <Route
            path={Links.newPrescription}
            element={<NewPrescription></NewPrescription>}
          />

          <Route
            path={Links.facilityBasicDetails}
            element={<MyFacilityHome></MyFacilityHome>}
          />
          <Route
            path={Links.facilityService}
            element={<MyFacilityHome></MyFacilityHome>}
          />
          <Route
            path={Links.facilityStaff}
            element={<MyFacilityHome></MyFacilityHome>}
          />

          <Route
            path={Links.patientAnalytics}
            element={<Dashboard></Dashboard>}
          />
          <Route
            path={Links.schedulingAnalytics}
            element={<Dashboard></Dashboard>}
          />
          <Route
            path={Links.others}
            element={<label>This page is under construction</label>}
          />

          <Route
            path={Links.billing}
            element={
              <ProtectedRoutes route="Billing">
                <BillHome />
              </ProtectedRoutes>
            }
          />
          <Route
            path={Links.billingHome}
            element={
              <ProtectedRoutes route="Billing">
                <BillHome />
              </ProtectedRoutes>
            }
          />
          <Route path={Links.billingList} element={<BillList />} />
          <Route
            path={Links.enquiry}
            element={
              <ProtectedRoutes route="Enquiry">
                <EnquiryHome />
              </ProtectedRoutes>
            }
          />
          <Route
            path={Links.plans}
            element={
              <ProtectedRoutes route="Plans">
                <PlansHome />
              </ProtectedRoutes>
            }
          />
          <Route
            path={Links.reports}
            element={
              <ProtectedRoutes route="Report">
                <ReportHome />
              </ProtectedRoutes>
            }
          />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
        </Routes>
        {/* </Grid2> */}
      </Grid2>
    </Grid2>
  );
}

export default MasterPage;
